import "@/App.css";
import TelegramApp from "./components/TelegramApp";

function App() {
  return <TelegramApp />;
}

export default App;
